<script>

export default {
    name: "FinanceDashBoard",
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <div class="flex flex-wrap">
                <div class="w-full p-1 my-1 text-center text-white bg-blue-500 rounded">
                    <h5 class="font-medium text-base">Finance</h5>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `finance-dashboard.coas.index` }" class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-green-600"><i class="fas fa-cogs fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Chart Of Accounts</h5>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{name:`finance-dashboard.bill-payments.create`}"
                            class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-green-600">
                                    <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Bill Payments</h5>
                            </div>
                        </router-link>
                    </div>
                </div> <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{name:`finance-dashboard.assets.index`}"
                            class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600">
                                    <i class="fas fa-boxes fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Asset Managment</h5>
                            </div>
                        </router-link>
                    </div> 
                </div>
                 <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{name:`finance-dashboard.banking.deposit`}"
                            class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600">
                                    <i class="fas fa-boxes fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Banking Deposit</h5>
                            </div>
                        </router-link>
                    </div> 
                </div> 
                 <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{name:`finance-dashboard.coas.journalentries`}"
                            class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600">
                                    <i class="fas fa-boxes fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Journal Entry</h5>
                            </div>
                        </router-link>
                    </div> 
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{name:`finance-dashboard.banking.reconciliations`}"
                            class="flex flex-row items-center">
                            <div class="flex-shrink pr-2">
                                <div class="rounded-full p-5 bg-orange-600">
                                    <i class="fas fa-boxes fa-2x fa-inverse"></i></div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold uppercase text-gray-600">Banking Reconciliation</h5>
                            </div>
                        </router-link>
                    </div> 
                </div> 
            </div>
        </template>
    </tail-base-layout>
</template>
